(function ($) {
  $(document).ready(() => {
    const body = $('body');
    $('[data-toggle-search]').on('click', function (e) {
      body.toggleClass('search-open');
      e.preventDefault();
    });
  });
})(jQuery);